import Typography from '@mui/material/Typography';
import { t } from 'i18next'
import BillingSubscriptionsItemsRow from "./BillingSubscriptionsItemsRow";
import { useMemo } from 'react';
import { isEmpty } from 'lodash';

type BillingSubscriptionsItemsTableProps = {
    subscriptions: any;
    subscriptionSchedules: any;
}

function BillingSubscriptionsItemsTable({ subscriptions, subscriptionSchedules }: BillingSubscriptionsItemsTableProps) {


    const mappedSubs = useMemo(() => {

        let subscriptionsItemsAsArray = []
        let subscriptionSchedulesItemsAsArray = []

        if (!isEmpty(subscriptions)) {
            subscriptionsItemsAsArray = Object.keys(subscriptions)
                .map((pid) => subscriptions[pid])
        }

        if (!isEmpty(subscriptionSchedules)) {
            subscriptionSchedulesItemsAsArray = Object.keys(subscriptionSchedules)
                .map((pid) => subscriptionSchedules[pid])
        }

        return [...subscriptionsItemsAsArray, ...subscriptionSchedulesItemsAsArray]

    }, [subscriptions, subscriptionSchedules])



    if (isEmpty(mappedSubs)) {
        return <Typography variant="body2" color="inherit" noWrap sx={{ flexGrow: 1 }}>
            {t("billing:no_active_subscription")}
        </Typography>

    }
    return <>
        {mappedSubs.map(sub =>
            <BillingSubscriptionsItemsRow
                key={sub.id}
                lineItem={sub}
            />

        )}
    </>;
}

export default BillingSubscriptionsItemsTable;
